export default __webpack_public_path__ + "static/media/ic_ukraine.ddb75b91.svg";